import React, { useMemo } from "react";
import ReactEcharts from "echarts-for-react";

const LineGraph = ({ projects }) => {
  const selectedProjects = projects?.filter((project) => project?.selected && project.id !== "all");
  const seriesData = selectedProjects?.map((project) => ({
    name: project?.name,
    type: project?.type || "line",
    data: project?.data,
    lineStyle: {
      color: project?.color,
    },
    itemStyle: {
      color: project?.color,
    },
  }));

  const option = useMemo(
    () => ({
      tooltip: {
        trigger: "axis",
        position: function (point, params, dom, rect, size) {
          const [x, y] = point;
          const tooltipHeight = Math.min(size.contentSize[1], 200); // Max height 200px
          const chartHeight = size.viewSize[1];
          
          // If tooltip would go below chart bottom, show it above the point
          if (y + tooltipHeight > chartHeight) {
            return [x, Math.max(0, y - tooltipHeight - 20)];
          }
          
          return [x, y];
        },
        axisPointer: {
          type: 'line',
          lineStyle: {
            color: '#F97316',
            width: 1
          }
        },
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        borderColor: '#F97316',
        borderWidth: 1,
        padding: [8, 12],
        textStyle: {
          color: '#4B5563'
        },
        enterable: true, // Allow mouse to enter tooltip
        confine: true, // Keep tooltip within chart bounds
        appendToBody: true, // Append tooltip to body for better scrolling
        formatter: function(params) {
          // Create scrollable tooltip content
          const style = 'max-height:300px;overflow-y:auto;';
          let content = `<div style="${style}">`;
          content += `<div style="margin-bottom:8px">${params[0].axisValue}</div>`;
          
          // Sort params by value for better readability
          params.sort((a, b) => b.value - a.value);
          
          params.forEach(param => {
            content += `
              <div style="display:flex;align-items:center;margin:4px 0;">
                <span style="display:inline-block;width:10px;height:10px;border-radius:50%;background-color:${param.color};margin-right:8px;"></span>
                <span style="flex:1;min-width:100px;">${param.seriesName}</span>
                <span style="margin-left:20px;font-weight:500;">$${param.value}</span>
              </div>
            `;
          });
          content += '</div>';
          return content;
        }
      },
      grid: {
        left: "3%",
        right: "4%",
        bottom: "10%",
        top: "10%",
        containLabel: true
      },
      xAxis: {
        type: "category",
        boundaryGap: false,
        data: [
          "Mar", "Apr", "May", "Jun", "Jul", "Aug",
          "Sep", "Oct", "Nov", "Dec", "Jan", "Feb"
        ],
      },
      yAxis: {
        type: "value",
        axisLabel: {
          formatter: "${value}",
        },
      },
      series: seriesData,
    }),
    [seriesData]
  );

  return (
    <div className="w-full h-full">
      <ReactEcharts
        key={JSON.stringify(seriesData)}
        option={option}
        notMerge={true}
        style={{ height: "100%", width: "100%", marginTop: "-1.5rem" }}
      />
    </div>
  );
};

export default LineGraph;
